module.exports = __webpack_public_path__ + "img/thumbs-down.c23f0c0f.svg";